// @ts-nocheck vue mixin 文件暂时不会写
import { lxMC, lxMV, lxTag } from '@zhenguo/jssdk/lx'

export default {
  props: {
    mcbid: String,
    mvbid: String,
    lab: {
      type: Object,
      default: () => ({}),
    },
    tag: {
      type: Array,
    },
  },
  methods: {
    reportMV(staticLib = {}) {
      lxMV(this.mvbid, {
        ...staticLib,
        ...this.lab,
      })
    },
    reportMC(staticLib = {}) {
      lxMC(this.mcbid, {
        ...staticLib,
        ...this.lab,
      })
    },
    reportTag() {
      if (this.tag) {
        if (Array.isArray(this.tag[0])) {
          for (const i of this.tag) {
            if (Array.isArray(i)) {
              lxTag(...i)
            }
          }
        } else {
          lxTag(...this.tag)
        }
      }
    },
  },
}
